import React from 'react';
import { MapPin, Clock, Phone, Navigation } from 'lucide-react';
import { outlets, BRAND } from '../mock';

const Outlets = () => {
  const outlet = outlets[0];

  return (
    <section id="outlets" className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12 reveal">
          <span className="inline-block px-3 py-1 rounded-full bg-[color:var(--brand-50)] text-[color:var(--brand)] text-xs font-semibold tracking-wider uppercase mb-3">Lokasi</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-[color:var(--ink)]">
            Outlet <span className="text-[color:var(--brand)]">Trust Me Laundry</span>
          </h2>
          <p className="text-[color:var(--muted)] mt-3">Kunjungi outlet kami di Jakarta Selatan.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-stretch">
          {/* Info card */}
          <div className="reveal order-2 lg:order-1">
            <div className="h-full bg-white rounded-3xl border border-[color:var(--brand-50)] p-7 lg:p-9 shadow-sm">
              <div className="inline-flex items-center gap-2 bg-[color:var(--brand-50)] rounded-full px-4 py-1.5 mb-5">
                <MapPin className="w-4 h-4 text-[color:var(--brand)]" />
                <span className="text-xs font-semibold text-[color:var(--brand)]">{outlet.city}</span>
              </div>

              <h3 className="font-display text-2xl lg:text-3xl font-extrabold text-[color:var(--ink)]">{outlet.name}</h3>

              <div className="mt-6 space-y-5">
                <div className="flex items-start gap-4">
                  <div className="h-10 w-10 rounded-xl bg-[color:var(--brand-50)] flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-5 h-5 text-[color:var(--brand)]" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-wider text-[color:var(--muted)] font-semibold">Alamat</div>
                    <div className="text-[color:var(--ink)] mt-1 leading-relaxed">{outlet.address}</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="h-10 w-10 rounded-xl bg-[color:var(--brand-50)] flex items-center justify-center flex-shrink-0">
                    <Clock className="w-5 h-5 text-[color:var(--brand)]" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-wider text-[color:var(--muted)] font-semibold">Jam Operasional</div>
                    <div className="text-[color:var(--ink)] mt-1 font-semibold">Senin – Minggu</div>
                    <div className="text-[color:var(--muted)] text-sm">08:00 – 20:00 WIB</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="h-10 w-10 rounded-xl bg-[color:var(--brand-50)] flex items-center justify-center flex-shrink-0">
                    <Phone className="w-5 h-5 text-[color:var(--brand)]" />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-wider text-[color:var(--muted)] font-semibold">Kontak</div>
                    <a href={`tel:${BRAND.phoneLink}`} className="text-[color:var(--ink)] mt-1 font-semibold hover:text-[color:var(--brand)] block">{BRAND.phone}</a>
                  </div>
                </div>
              </div>

              <div className="mt-7 flex flex-wrap gap-3">
                <a href={BRAND.mapLink} target="_blank" rel="noreferrer" className="btn-brand flex items-center gap-2">
                  <Navigation className="w-4 h-4" /> Petunjuk Arah
                </a>
                <a href={BRAND.whatsapp} target="_blank" rel="noreferrer" className="btn-brand-outline">Hubungi WhatsApp</a>
              </div>
            </div>
          </div>

          {/* Map */}
          <div className="reveal order-1 lg:order-2">
            <div className="rounded-3xl overflow-hidden border border-[color:var(--brand-50)] shadow-xl h-full min-h-[420px]">
              <iframe
                title="Lokasi Trust Me Laundry"
                src={BRAND.mapEmbed}
                className="w-full h-full min-h-[420px]"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Outlets;
